import {
  POST_EVENT_URL,
  RESOURCES_URL,
  CREATE_COMPANY_URL,
  TENDERS_LIST_URL,
  RESPOND_TO_TENDER_URL
} from 'global-constants';

export const SIGNUP_HELP_TEXTS = {
  [CREATE_COMPANY_URL]: {
    btnId: 'create-company-signup-button',
    textOnLeft:
      'To add a new Company to our Unissu directory, please register first',
    textOnRight: 'Sign up for free to add a company'
  },
  [RESOURCES_URL]: {
    btnId: 'create-resource-signup-button',
    textOnLeft: 'To submit your content you must register with Unissu first',
    textOnRight: 'Sign up for free to add your content'
  },
  [POST_EVENT_URL]: {
    btnId: 'create-event-signup-button',

    textOnLeft: 'To add an event to our Unissu list, please register first',
    textOnRight: 'Sign up for free to add an event'
  },
  [TENDERS_LIST_URL]: {
    btnId: 'my-projects-signup-button',
    textOnLeft:
      'To see all procurement projects on the site, register with us.',
    textOnRight: 'Sign up for free.',
    bullets: [
      'Save time! Let us help you find the right PropTech solution',
      'We scan the entire global market on your behalf',
      'Totally free',
      'Over $100 Billion dollars in assets already tendered'
    ]
  },
  [RESPOND_TO_TENDER_URL]: {
    btnId: 'respond-to-project-signup-button',
    textOnLeft:
      'To see all procurement projects on the site, register with us.',
    textOnRight: 'Sign up for free.',
    bullets: [
      'Save time! Let us help you find the right PropTech solution',
      'We scan the entire global market on your behalf',
      'Totally free',
      'Over $100 Billion dollars in assets already tendered'
    ]
  }
};
